import * as React from "react";

import { RobotoIconButton, RobotoTooltip } from "@/shared/components";
import { FileRecord } from "@/shared/domain/files";
import { OpenInNewIcon } from "@/shared/foundation/icons/mui";
import { LoggerService } from "@/shared/services/LoggerService";

import { useGetFileContents } from "../hooks";

interface OpenFileInNewTabButtonProps {
  fileRecord: FileRecord;
}

export function OpenFileInNewTabButton({
  fileRecord,
}: OpenFileInNewTabButtonProps) {
  const getFileContentsAsUrl = useGetFileContents();

  const [error, setError] = React.useState<string | null>(null);

  const openFile = () => {
    getFileContentsAsUrl(fileRecord)
      .then((signedUrl: URL) => {
        window.open(signedUrl, "_blank", "noopener,noreferrer");
        setError(null);
      })
      .catch((error: unknown) => {
        LoggerService.error("Failed to open file in new tab", error);
        setError("Failed to open file. Try again.");
      });
  };

  return (
    <RobotoTooltip title={error || "Open file in new tab"}>
      <span>
        <RobotoIconButton
          eventName="FileOpenInNewWindowClicked"
          eventProperties={{ fileId: fileRecord.file_id }}
          onClick={openFile}
          sx={{ padding: "0.5rem" }}
          size="small"
        >
          <OpenInNewIcon
            style={{
              width: "1.25rem",
              height: "1.25rem",
            }}
          />
        </RobotoIconButton>
      </span>
    </RobotoTooltip>
  );
}
